module.exports = __webpack_public_path__ + "img/userprofile-icon.120d5621.svg";